import ContactUsSimpleForm from './ContactUsSimpleForm'
export default ContactUsSimpleForm
